// extracted by mini-css-extract-plugin
module.exports = {"ProjectType":"ProjectTypeTag_ProjectType__4OGpY"};